<template>
    <div
        class="background"
        :class="{
            'fixed-block': yPosition > 79,
        }"
    >
        <div class="finally-main" :class="{'zoomed': windowWidth <= 1440}">
            <div class="block-list">
                <!--     summary    -->
                <ul class="finally-list-one">
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ $t("page.tariffs.finally_calculation.standartPrice") }}
                            </p>
                            <p class="finally-list-one-text">${{ calculatedResult.summary.standardPrice }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ $t("page.tariffs.finally_calculation.months") }}
                            </p>
                            <p class="finally-list-one-text"> {{ calculatedResult.summary.monthCount }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.viber.title }}
                                <span :class="`icon-viber`"/>
                            </p>
                            <p class="finally-list-one-text"> {{ calculatedResult.summary.numberCountByMsg.viber }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.telegram.title }}
                                <span :class="`icon-telegram`"/>
                            </p>
                            <p class="finally-list-one-text">
                                {{ calculatedResult.summary.numberCountByMsg.telegram }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.whatsapp.title }}
                                <span :class="`icon-whatsapp`"/>
                            </p>
                            <p class="finally-list-one-text">
                                {{ calculatedResult.summary.numberCountByMsg.whatsapp }} </p>
                        </div>
                    </li>
                </ul>

                <!--     benefit    -->
                <ul class="finally-list-one">
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ $t("page.tariffs.finally_calculation.discount") }}
                            </p>
                            <p class="finally-list-one-text">{{ calculatedResult.benefit.discount }}%</p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ $t("page.tariffs.finally_calculation.discountPrice") }}
                            </p>
                            <p class="finally-list-one-text">${{ calculatedResult.benefit.discountPrice }}</p>
                        </div>
                    </li>
                </ul>

                <!--     Single price by tariff    -->
                <ul class="finally-list-one">
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p
                                class="finally-list-one-text bold"
                            >
                                {{ $t(`page.tariffs.finally_calculation.title`) }}
                            </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.viber.title }}
                                <span :class="`icon-viber`"/>
                            </p>
                            <p class="finally-list-one-text">${{ calculatedResult.priceByMonthCount.viber }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.telegram.title }}
                                <span :class="`icon-telegram`"/>
                            </p>
                            <p class="finally-list-one-text">${{ calculatedResult.priceByMonthCount.telegram }} </p>
                        </div>
                    </li>
                    <li class="finally-list-one-item">
                        <div class="finally-list-one-poss">
                            <p class="finally-list-one-text">
                                {{ MESSENGERS.whatsapp.title }}
                                <span :class="`icon-whatsapp`"/>
                            </p>
                            <p class="finally-list-one-text">${{ calculatedResult.priceByMonthCount.whatsapp }} </p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="finally-price">
                <div class="finally-price_position">
                    <div class="finally-list-one-text">{{ $t("page.tariffs.amount_to_pay") }}:</div>
                    <div class="sum">$ {{ calculatedResult.totalCost }}</div>
                </div>
                <button class="finally-button" @click="onPay">
                    {{
                        $t(
                            btn === "calculator"
                                ? "general.next_to"
                                : "page.integration.numbers_table.connected_numbers.pay_button"
                        )
                    }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
// core
import {computed, ref, onBeforeUpdate, watchEffect} from "vue";
import { useI18n } from "vue-i18n";
import {useWindowSize} from "@vueuse/core";

const { t } = useI18n();
const {width: windowWidth} = useWindowSize()
// store
import {useStore} from "vuex";

// data
import MESSENGERS from "@/data/messengers";

// services
import {tariffCalculator, MODES} from "@/services/TariffCalculator/tariffCalculator";

//
const props = defineProps({
    calculateData: {
        type: [Array, Object],
        required: true,
    },
    btn: String,
    wrapperHeight: [String, Number],
    yPosition: {
        type: Number,
        default: 0,
    },
});

const emit = defineEmits(["priceOneNumberOneMonth"]);
const store = useStore();

const bgHeight = ref("calc(100vh - 186px)");
const isFixed = ref(false);

const calculatedResult = computed(() => {
    return tariffCalculator(props.calculateData, MODES[props.btn.toUpperCase()], t)
});

watchEffect(() => {
    emit('priceOneNumberOneMonth', calculatedResult.value.priceByMonthCount);
})

const hasNoSelectedNumbers = (data) => {
    return !data.viber?.length && !data.telegram?.length && !data.whatsapp?.length;
};

const openDialogWith = (store, name, params = {}) => {
    store.commit("openDialog", {name, params});
};

function onPay() {
    const {btn, calculateData} = props;

    if (btn !== "payment") {
        store.commit("setTariffsTab", "payment");
        return;
    }

    if (hasNoSelectedNumbers(calculateData)) {
        openDialogWith(store, "InformationDialog", {info: "selectedNumberError"});
        return;
    }

    store.commit("numbers/SET_SELECTED_NUMBERS", calculateData);
    store.state.componentDialog = "TariffSelectNumberDialog";
    openDialogWith(store, "TariffSelectNumberDialog", {
        totalCost: calculatedResult.value.totalCost,
    });
}


function stickyBlock() {
    if (props.yPosition === 0) {
        isFixed.value = false;
        bgHeight.value = "calc(100vh - 186px)";
    } else if (props.yPosition <= 79) {
        bgHeight.value = `calc(100vh - 166px + ${props.yPosition}px)`;
        isFixed.value = true;
    } else if (props.yPosition > 0) {
        bgHeight.value = "calc(100vh - 91px)";
        isFixed.value = false;
    }

    const bottomYPosition = props.yPosition + innerHeight;
    const wrapperH = parseFloat(props.wrapperHeight);

    if (bottomYPosition > wrapperH + 88) {
        bgHeight.value = `calc(100vh + 15px - ${bottomYPosition - wrapperH}px)`;
    }
}

onBeforeUpdate(() => {
    stickyBlock();
});

</script>

<style scoped lang="scss">
.icon-viber {
    font-size: 33px;
    color: #7c509a;
}

.icon-telegram {
    font-size: 39px;
    color: #27a6e5;
}

.icon-whatsapp {
    font-size: 28px;
    padding-left: 5px;
    color: #25d366;
    width: 35px;
}

.finally-price {
    background: var(--general-color);
    border-radius: 11px;
    padding: 10px 15px;
    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    &_position {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}

.block-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.item-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.finally-list-one {
    background-color: var(--block-color);
    padding: 15px;
    border-radius: 11px;
}

.sum {
    color: white;
    font-size: 35px;
    font-weight: 700;
    line-height: 42px;
    font-family: "Gilroy";
}

.finally-button {
    max-width: 205px;
    width: 100%;
    flex: 1;
    background-color: white;
    border-radius: 7px;
    border: 1px solid;
    color: var(--general-color);
    padding: 14px 22px;
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
    font-family: "Gilroy";
    text-transform: uppercase;

    &:hover {
        background: none;
        color: white;
        transition: 0.25s;
        border-color: white;
    }
}

.discount {
    margin-top: 20px;
    margin-bottom: 20px;
}

.finally-list-one-poss {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--block-color);
    border-radius: 11px;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 45%;
        width: 100%;
        border-bottom: 1px dashed lightgray;
    }
}

.finally-list-one-text {
    font-size: 14px;
    line-height: 26px;
    font-family: "Gilroy";
    font-weight: 500;
    margin: 0;
    z-index: 1;
    position: relative;
    background-color: var(--block-color);
    align-items: center;
    display: flex;
    margin-bottom: 5px;
}

.finally-price_position > .finally-list-one-text {
    background: transparent;
    color: white;
}

.finally-list-one-text.bold {
    font-weight: bold;
}

.finally-main {
    position: relative;
    min-width: 260px;
    max-width: 467px;
    width: 100%;
    gap: 20px;
    padding: 15px;
    margin: 1px 0;
    background-color: white;
    border-radius: 11px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (max-width: 400px) {
        gap: 60px;
    }

    &.zoomed {
        .finally-list-one,
        .finally-price {
            zoom: 0.8;
        }
    }
}

.background {
    display: flex;
    padding: 1px;
    background: linear-gradient(to bottom, #27a6e5 0%, #7a70df 100%);
    border-radius: 13px;
    min-width: 260px;
    max-width: 467px;
    width: 100%;
    min-height: v-bind(bgHeight);
    max-height: 760px;
    transition: all 0.8s cubic-bezier(0, 0.17, 0.07, 1.65);
}

@media screen and (max-width: 1480px) {
    .finally-price {
        flex-direction: column;
        justify-content: center;

        &_position {
            display: block;
            width: auto;

            .finally-list-one-text {
                font-size: 18px;
            }

            .sum {
                text-align: center;
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    @media screen and (min-width: 900px) {
        .finally-list-one {
            zoom: 0.8;
        }
        .block-list {
            flex-direction: row;
            justify-content: space-between;

            ul {
                width: calc(100% / 3);
            }
        }
    }

    .finally-price {
        flex-direction: row;
        justify-content: space-between;
    }
}

@media screen and (max-width: 500px) {
    .finally-main {
        width: 100%;

        .finally-price {
            flex-direction: column;
            justify-content: center;

            &_position {
                display: block;
                width: auto;

                .finally-list-one-text {
                    font-size: 18px;
                }

                .sum {
                    text-align: center;
                }
            }
        }

        .finally-button {
            margin-top: 10px;
            padding: 9px 44px;
            font-size: 14px;
        }
    }
}

@media screen and (max-width: 540px) {
    .finally-main {
    }
}

@media screen and (min-width: 540px) and (max-width: 1220px) {
    .background,
    .finally-main {
        max-width: none;
        min-height: auto;
    }
}

@media screen and (min-width: 1221px) {
    .fixed-block {
        position: sticky;
        top: 90px;
    }
}
</style>
